export var FileErrorStatus;
(function (FileErrorStatus) {
    FileErrorStatus["FileMaxExceeded"] = "file-too-large";
    FileErrorStatus["MaxFilesExceeded"] = "max-files";
})(FileErrorStatus || (FileErrorStatus = {}));
